interface EsModule {
  __esModule: true;
  default: string;
}

type MediaSourceType = EsModule | string;

const isEsModule = (src: MediaSourceType): src is EsModule =>
  src != null && typeof src === 'object' && src['__esModule'] === true && src['default'] != null;

type AssetMap<T> = {
  [P in keyof T]: MediaSourceType;
};

type NormalizedAssetMap<T> = {
  [P in keyof T]: string;
};

export const normalizeAssetMap = <T extends AssetMap<T>>(assetMap: T): NormalizedAssetMap<T> => {
  const normalized: NormalizedAssetMap<T> = {} as NormalizedAssetMap<T>;
  for (const key in assetMap) {
    const source = assetMap[key];
    if (isEsModule(source)) {
      normalized[key] = source['default'];
    } else if (typeof source === 'string') {
      normalized[key] = source;
    }
  }
  return normalized;
};
